// Auto-generated. Full namespace bundle for cross-lib use.
export default {
  mode_switcher: {
    in_review: 'In Review',
    targeted_alerts: 'Targeted Intelligence',
    non_targeted_alerts: 'Strategic Intelligence'
  },
  alert_assignee: {
    unassigned: 'Unassigned',
    assign_user: 'Assign User',
    assign_to_me: 'Assign to me (%{name})',
    assigned_to_me: 'Assigned to me',
    assignee: 'Assignee: %{name}',
    update_error: 'Failed to update assignee'
  },
  category: {
    fraud: 'Fraud',
    phishing: 'Phishing',
    attackware: 'Attackware',
    supply_chain: 'Supply Chain',
    brand: 'Brand',
    data: 'Data',
    vulnerabilities: 'Vulnerabilities',
    other: 'Other'
  },
  type: {
    refund_fraud: 'Refund Fraud',
    carding: 'Carding',
    coupon_fraud: 'Coupon Fraud',
    money_laundering: 'Money Laundering',
    victim_report: 'Victim Report',
    malicious_insider: 'Malicious Insider',
    extortion: 'Extortion',
    phishing_email: 'Phishing Email',
    phishing_kit: 'Phishing Kit',
    phishing_website: 'Phishing Website',
    lookalike_domain: 'Look-Alike Domain',
    phishing_target_list: 'Phishing Target List',
    malicious_file: 'Malware',
    reconnaissance: 'Reconnaissance',
    automated_attack_tools: 'Automated Attack Tools',
    business_logic_bypass: 'Business Logic Bypass',
    target_list: 'Target List',
    official_social_media_profile: 'Official Social Media Profile',
    impersonation: 'Impersonation',
    intellectual_property_infringement: 'Intellectual Property Infringement',
    unauthorized_trading: 'Unauthorized Trading',
    negative_sentiment: 'Brand Reputation',
    fake_job_posting: 'Fake Job Posting',
    defacement: 'Defacement',
    compromised_pii: 'Compromised PII',
    internal_information_disclosure: 'Internal Information Disclosure',
    compromised_payment_cards: 'Compromised Payment Cards',
    compromised_employee_credentials: 'Compromised Employee Credentials',
    compromised_customer_credentials: 'Compromised Customer Credentials',
    compromised_access_token: 'Compromised Access Token',
    ransomware: 'Ransomware',
    exposed_web_interfaces: 'Exposed Web Interfaces',
    hijackable_subdomains: 'Hijackable Subdomains',
    website_vulnerabilities: 'Website Vulnerabilities',
    vulnerabilities: 'Vulnerabilities',
    exposed_cloud_storage: 'Exposed Cloud Storage',
    exploitable_ports: 'Exploitable Ports',
    mail_servers_in_blacklist: 'Mail Servers in Blocklist',
    server_connected_to_botnet: 'Server connected to Botnet',
    email_security_issues: 'Email Security',
    certificate_authority_issues: 'Certificate Authority Issues',
    user_defined_saved_query: 'User Defined Saved Query',
    other: 'Other',
    ssl_tls: 'SSL/TLS Issues',
    vendor_incident: 'Vendor Incident',
    web_app_security: 'Web App Security'
  },
  subtype: {
    vulnerable_technology_detected_on_manually_added_technology: 'Vulnerable Manually Added Technology Detected',
    tls_outdated_version_ssl_tls_supported: 'Outdated SSL/TLS Version Supported',
    tls_no_forward_secrecy: "Cipher Suites Don't Support Forward Secrecy",
    tls_latest_version_not_supported: 'TLS 1.3 Not Supported',
    tls_server_has_known_vulnerability: 'Known SSL/TLS Vulnerability Detected',
    tls_insecure_cipher_suites: 'Insecure SSL/TLS Cipher Suites Detected',
    tls_weak_cipher_suites: 'Weak SSL/TLS Cipher Suites Detected',
    tls_server_accepts_insecure_renegotiation: 'Insecure SSL/TLS Renegotiation Enabled',
    ssl_tls_certificate_expiry: 'SSL/TLS Certificate Expiry Notice',
    exposed_directory_listing: 'Exposed Directory Listing',
    fraudulent_account_temp_phone: 'Fraudulent Account Registered Using Temporary Phone Number',
    potential_ddos_attack: 'Potential DDoS Attack',
    breached_data_potentially_related_to_company: 'Breached Data Potentially Related to Company',
    company_employee_private_access_token_exposed: 'Company Employee Private Access Token Exposed',
    malicious_insider_disclosing_company_internal_information:
      'Malicious Insider Disclosing Company Internal Information',
    ransomware_attack_targeting_company: 'Ransomware Attack Targeting Company',
    company_customer_credentials_offered_for_sale: 'Company Customer Credentials Offered for Sale',
    company_employee_credentials_offered_for_sale: 'Company Employee Credentials Offered for Sale',
    modified_application_potentially_bypassing_company_business_logic:
      'Modified Application Potentially Bypassing Company Business Logic',
    cashout_tutorial_targeting_company: 'Cashout Tutorial Targeting Company',
    lookalike_subdomain_potentially_targeting_company: 'Look-Alike Subdomain Potentially Targeting Company',
    fraudulent_activity_reported_by_company_customer: 'Fraudulent Activity Reported by Company Customer',
    malicious_insider_enabling_access_to_company_internal_information:
      'Malicious Insider Enabling Access to Company Internal Information',
    malicious_file_targeting_company_employees: 'Malicious File Targeting Company Employees',
    brute_force_tool_targeting_company: 'Brute Force Tool Targeting Company',
    company_confidential_file_offered_for_sale: 'Company Confidential File Offered for Sale',
    malicious_insider_engaged_in_fraudulent_activity: 'Malicious Insider Engaged in Fraudulent Activity',
    phishing_kit_targeting_company: 'Phishing Kit Targeting Company',
    brand_abusing_website_impersonating_company: 'Brand Abusing Website Impersonating Company',
    company_source_code_exposed: 'Company Source Code Exposed',
    company_coupons_offered_for_sale: 'Company Coupons Offered for Sale',
    missing_company_domain_caa_records_detected: 'Missing Company Domain CAA Records Detected',
    pii_for_multiple_company_customers_offered_for_sale: 'PII for Multiple Company Customers Offered for Sale',
    company_employee_corporate_credentials_exposed: 'Company Employee Corporate Credentials Exposed',
    misconfigured_company_domain_dmarc_records_detected: 'Misconfigured Company Domain DMARC Records Detected',
    social_media_account_impersonating_company: 'Social Media Account Impersonating Company',
    social_media_account_impersonating_company_executive: 'Social Media Account Impersonating Company Executive',
    company_website_defaced: 'Company Website Defaced',
    web_application_vulnerability_exploit_published: 'Web Application Vulnerability Exploit Published',
    carding_tutorial_targeting_company: 'Carding Tutorial Targeting Company',
    exploitable_port_on_company_server_detected: 'Exploitable Port on Company Server Detected',
    cashout_services_targeting_company: 'Cashout Services Targeting Company',
    company_customer_payment_cards_offered_for_sale: 'Company Customer Payment Cards Offered for Sale',
    misconfigured_company_domain_spf_records_detected: 'Misconfigured Company Domain SPF Records Detected',
    fraudulent_refund_services_targeting_company: 'Fraudulent Refund Services Targeting Company',
    fraudulent_refund_tutorial_targeting_company: 'Fraudulent Refund Tutorial Targeting Company',
    malicious_file_employee_machine_infected_by_malware: 'Employee Machine Infected by Malware',
    fake_job_posting_impersonating_company: 'Fake Job Listing Impersonating Company',
    company_executive_pii_offered_for_sale: 'Company Employee PII Offered for Sale',
    missing_company_domain_dmarc_records_detected: 'Missing Company Domain DMARC Records Detected',
    extortion_scheme_targeting_company_executive: 'Extortion Scheme Targeting Company Executive',
    company_asset_designated_on_target_list: 'Company Asset Designated on Target List',
    suspicious_social_media_account_targeting_company_customers:
      'Suspicious Social Media Account Targeting Company Customers',
    company_product_unauthorized_resale: 'Company Product Unauthorized Resale',
    company_internal_email_correspondence_exposed: 'Company Internal Email Correspondence Exposed',
    company_mail_server_blacklisted: 'Company Mail Server Blocklisted',
    company_intellectual_property_used_without_authorization:
      'Company Intellectual Property Used without Authorization',
    company_customer_credentials_exposed: 'Company Customer Credentials Exposed',
    company_executive_designated_on_target_list: 'Company Executive Designated on Target List',
    potential_reconnaissance_on_company_domain: 'Potential Reconnaissance on Company Domain',
    company_employee_payment_cards_exposed: 'Company Employee Payment Cards Exposed',
    tool_potentially_bypassing_company_business_logic: 'Tool Potentially Bypassing Company Business Logic',
    counterfeit_company_product_offered_for_sale: 'Counterfeit Company Product Offered for Sale',
    credential_stuffing_tool_targeting_company: 'Credential Stuffing Tool Targeting Company',
    invalid_ssl_certificate_on_company_web_interface: 'Invalid SSL Certificate on Company Web Interface',
    lookalike_domain_potentially_targeting_company: 'Look-Alike Domain Potentially Targeting Company',
    data_scraping_tool_for_company_application: 'Data Scraping Tool for Company Application',
    exposed_company_web_interface: 'Exposed Company Web Interface',
    browser_extension_potentially_bypassing_company_business_logic:
      'Browser Extension Potentially Bypassing Company Business Logic',
    company_subdomain_vulnerable_to_hijacking: 'Company Subdomain Vulnerable to Hijacking',
    vulnerability_scanner_targeting_company: 'Vulnerability Scanner Targeting Company',
    active_phishing_website_targeting_company: 'Active Phishing Website Targeting Company',
    email_phishing_campaign_targeting_company: 'Email Phishing Campaign Targeting Company',
    malicious_file_targeting_company_customers: 'Malicious File Targeting Company Customers',
    company_coupons_prematurely_exposed: 'Company Coupons Prematurely Exposed',
    company_server_identified_as_connected_to_botnet: 'Company Server Identified as Connected to Botnet',
    missing_company_domain_spf_records_detected: 'Missing Company Domain SPF Records Detected',
    pii_for_multiple_company_customers_exposed: 'PII for Multiple Company Customers Exposed',
    company_customer_credentials_and_pii_exposed: 'Company Customer Credentials and PII Exposed',
    carding_services_targeting_company: 'Carding Services Targeting Company',
    malicious_url_distributed_on_company_social_media_profile:
      'Malicious URL Distributed on Company Social Media Profile',
    company_generated_credit_cards_detected: 'Company Generated Credit Cards Detected',
    exposed_company_cloud_storage_bucket_detected: 'Exposed Company Cloud Storage Bucket Detected',
    misconfigured_company_domain_caa_records_detected: 'Misconfigured Company Domain CAA Records Detected',
    potentially_exploitable_web_application_vulnerability_detected:
      'Potentially Exploitable Web Application Vulnerability Detected',
    company_executive_pii_exposed: 'Company Employee PII Exposed',
    mobile_app_impersonating_company: 'Mobile App Impersonating Company',
    mobile_app_distributed_unofficially: 'Mobile App Distributed Unofficially',
    company_customer_payment_cards_exposed: 'Company Customer Payment Cards Exposed',
    company_customer_payment_cards_and_pii_exposed: 'Company Customer Payment Cards and PII Exposed',
    company_confidential_file_exposed: 'Company Confidential File Exposed',
    extortion_scheme_targeting_company: 'Extortion Scheme Targeting Company',
    potential_scanner_output_published: 'Potential Scanner Output Published',
    negative_sentiment_targeting_company: 'Negative Sentiment Targeting Company',
    fake_job_posting_impersonating_company_employee: 'Fake Job Listing Impersonating Company Employee',
    company_social_media_profile_defaced: 'Company Social Media Profile Defaced',
    company_employee_third_party_credentials_exposed: 'Company Employee Third-Party Credentials Exposed',
    company_domain_ssl_tls_issue_detected: 'Company Domain SSL/TLS Issues Detected',
    third_party_vendor_breached: 'Third Party Vendor Breached',
    ransomware_attack_targeting_third_party_vendor: 'Ransomware Attack Targeting Third Party Vendor',
    vulnerable_technology_detected_on_exposed_company_asset: 'Vulnerable Technology Detected On Exposed Company Asset',
    highly_ranked_cve_found_on_a_technology: 'Highly Ranked CVE Found on a Known Technology',
    user_defined_saved_query_hit: 'User Defined Saved Query Hit',
    exploitable_vulnerability_found_on_company_asset: 'Exploitable Vulnerability found on a Company Asset',
    web_app_security_missing_hsts_header_detected: 'Missing HSTS Header Detected On Exposed Company Asset',
    web_app_security_misconfigured_hsts_header_detected: 'Misconfigured HSTS Header Detected On Exposed Company Asset',
    web_app_security_missing_x_frame_options_header_detected:
      'Missing X-Frame-Options Header Detected on Exposed Company Asset',
    web_app_security_misconfigured_x_frame_options_header_detected:
      'Misconfigured X-Frame-Options Header Detected on Exposed Company Asset',
    web_app_security_missing_x_content_type_options_header_detected:
      'Missing X-Content-Type-Options Header Detected on Exposed Company Asset',
    web_app_security_misconfigured_x_content_type_options_header_detected:
      'Misconfigured X-Content-Type-Options Header Detected on Exposed Company Asset',
    web_app_security_missing_content_security_policy_header_detected:
      'Missing Content-Security-Policy Header Detected on Exposed Company Asset',
    other: 'Other',
    exploit_found_on_company_asset: 'An Exploit found on a Company Asset',
    web_app_security_missing_referrer_policy_header_detected:
      'Web App Security Missing Referrer Policy Header Detected',
    web_app_security_missing_x_permitted_cross_domain_policies_header_detected:
      'Web App Security Missing X Permitted Cross Domain Policies Header Detected'
  },
  targetedVector: {
    customer: 'Customer',
    employee: 'Employee',
    business: 'Business',
    iocType: 'Type',
    iocValue: 'Value',
    whois: 'WHOIS'
  },
  source_category: {
    forum: 'Forum',
    darknet: 'Darknet',
    paste_site: 'Paste Site',
    file_sharing: 'File Sharing',
    deface_site: 'Deface Site',
    blog: 'Blog',
    marketplace: 'Marketplace',
    cvv_shop: 'CVV Shop',
    social_network: 'Social Network',
    code_repository: 'Code Repository',
    chat: 'Chat',
    search_engine: 'Search Engine',
    antivirus_repository: 'Antivirus Repository',
    malware_log: 'Malware Log',
    attack_surface_monitoring: 'Attack Surface Monitoring',
    whois: 'Whois',
    breach_monitor: 'Breach Monitor',
    leaked_data: 'Leaked Data',
    ransomware: 'Ransomware',
    dump: 'Dump',
    online_protection: 'Online Protection',
    phishing_detection: 'Phishing Detection'
  },
  impact: {
    revenue_loss: 'Revenue Loss',
    customer_churn: 'Customer Churn',
    account_takeover: 'Account Takeover',
    user_data_compromise: 'User Data Compromise',
    data_compromise: 'Data Breach/Compromise',
    unauthorized_access: 'Unauthorized Access',
    financial_penalties: 'Financial Penalties/Fines',
    competitive_advantage_loss: 'Loss of Competitive Advantage',
    service_disruption: 'Service Disruption',
    brand_degradation: 'Brand/Image Degradation'
  },
  status: {
    unread: 'Unread',
    read: 'Read',
    archived: 'Archive',
    filter_label: 'Status',
    current_status: 'Current status',
    options: {
      acknowledged: 'Acknowledged',
      open: 'Open',
      resolved: 'Resolved',
      discard: 'Discarded',
      closed: 'Closed'
    },
    change: 'Change status',
    types: {
      acknowledged: 'Acknowledged',
      open: 'Open',
      closed: 'Closed'
    },
    changed_by_user: 'By %{user}',
    closure_reason: 'Closure Reason:',
    discard_reason: 'Discard Reason:',
    closed: 'Resolve',
    acknowledged: 'Acknowledge',
    modal: {
      validFindings: {
        validPaymentCards: {
          title: 'Valid Payment Cards',
          message: 'Amount of valid payment cards: '
        },
        validCredentials: {
          title: 'Valid Credentials',
          message: 'Amount of valid credentials: '
        },
        maxFindingsMsg: "Please enter a number that's %{maxFindings} or less"
      }
    }
  },
  headers: {
    last_update: 'Last Update',
    status: 'Status',
    title: 'Title',
    subtype: 'Subtype',
    confidence: 'Confidence',
    severity: 'Severity',
    created: 'Created',
    closed: 'Closed',
    closure_reason: 'Closure Reason',
    closure_reason_description: 'Closure Reason Details',
    id: 'Item ID',
    alertId: 'Alert ID',
    brand: 'Organization',
    activeAlerts: 'Total Active Alerts',
    criticalAlerts: 'Critical Active Alerts',
    resolved_title: 'Mean Time to Resolve \n(Monthly avg.)',
    securityScore: 'Security Score',
    attack_surface_monitored_assets: 'Attack Surface Monitored Assets',
    attack_surface_unvalidated_assets: 'Attack Surface Unvalidated Assets',
    open_issues: 'Open Exposure Items',
    total_intel_items: 'Total Intel Items \n (Past month)',
    no_title: 'No Title',
    customer_id: 'Customer'
  },
  screenshot: {
    default: 'Supportive Screenshots'
  },
  cve: {
    cyberint_score: 'Score',
    name: 'ID',
    epss_percentile: 'EPSS Percentile',
    remote_access: 'Remotely Exploitable',
    vulnHosts: 'Vulnerable Hosts (Org-Wide)',
    vulnHostsTooltip:
      'Vulnerable Hosts reflect organization-wide exposure to this CVE and may not be limited to the asset in this alert',
    securityControls: 'Security Controls',
    cyberint_score_modification_date: 'Score Last Modified'
  },
  fields: {
    cipher_suites: 'Cipher Suites',
    assetGroup: 'Asset Group',
    coverage: 'Coverage',
    port: 'Port',
    vendor_name: 'Vendor Name',
    vendor_name_tooltip: 'Open Vendor card',
    vendor: 'Vendor',
    version: 'Version',
    technology: 'Technology',
    engagement: 'Engagement',
    followers: 'Followers',
    following: 'Following',
    go_to_lc: 'Go to Leaked Credentials screen',
    download_lc: 'Download Leaked Credentials file',
    found_on_idp: 'IDP User Exists',
    credentialStats: 'Credential Stats',
    cardsStats: 'Cards Stats',
    detected: 'Detected',
    go_to_cve: 'Go to CVE Intel',
    remote_exploit_cve: 'Remotely Exploitable CVE',
    scan_more: 'Scan more alerts',
    load_more: 'Load more',
    id: 'ID',
    modificationReason: 'Modification Reason',
    alert_id: 'Alert id',
    customer_id: 'Tenant',
    selected: 'Alerts selected',
    selectAllAlerts: 'Select all %{count} alerts',
    clearSelection: 'Clear selection',
    alerts: 'Alerts',
    ports: 'Ports',
    cves: 'CVEs',
    cve: 'CVE',
    operational_dashboards: 'Operational Dashboard',
    full_details: 'Full Details',
    site_status: 'Site Status',
    active: 'Active',
    not_active: 'Not active',
    secured: 'Secured',
    unsecured: 'Unsecured',
    not_required: 'Not Required',
    in_review: 'In Review',
    draft: 'Draft',
    candidate: 'Candidate',
    discarded: 'Discarded',
    change: 'Change',
    change_status: 'Change Status',
    change_severity: 'Change Severity',
    change_confidence: 'Change Confidence',
    add_note: 'Add Note',
    add_discussion: 'Open a Discussion',
    na: 'N/A',
    cve_missing_feature:
      'CVE Intelligence module subscription is required for viewing the service-related Vulnerabilities Intelligence',
    cve_missing_feature_learn_more: 'Learn More',
    search_cves: 'Search CVEs',
    no_cves_detected: 'No CVEs Detected',
    search_product_related_cves: 'Search Product CVEs',
    search_for_more_cves: 'See All Related Technology CVEs',
    expired: 'Expired',
    about_to_expire: 'About to Expire',
    unknown: 'Unknown',
    cves_link: 'CVEs',
    cve_exploited_by: 'Known to be exploited by',
    top_notable_vulnerabilities: 'Top Notable Vulnerabilities',
    research_news_feed: "Cyberint's Research News",
    set_to_closed: 'Set to Closed',
    closure_reason: 'Closure Reason',
    resolved: 'Resolved',
    irrelevant: 'Irrelevant',
    false_positive: 'False Positive',
    duplication: 'Duplication',
    different_type: 'Different type',
    aggregated_into_another_alert: 'Aggregated into another alert',
    incorrect_correlation_to_customer: 'Incorrect correlation to customer',
    corrupted_data: 'Corrupted data',
    inactive_true_positive: 'Inactive true positive',
    out_of_scope_true_positive: 'Out of scope true positive',
    select_discard_reason: 'Discard Reason',
    category: 'Category',
    type: 'Type',
    impact: 'Impact',
    collection_date: 'Collection Date',
    updated: 'Updated',
    last_update: 'Last Update',
    last_modified: 'Last Update',
    last_content_update: 'Last content update',
    detection_reasons: 'Detection Reason',
    detection_source_source7_tooltip:
      'The source of this phishing alert does not support generating screenshots that contain a URL',
    source_agentic_aev_label: 'Agentic Exposure Validation',
    source_agentic_aev_tooltip:
      'This alert was generated by an AI agent that autonomously discovers and validates exploitable vulnerabilities on company assets.',
    agentic_aev_deepdive_title: 'Exploitation deep-dive',
    url_reputation: 'URL Reputation',
    code_leak_sample: 'Exposed Code',
    author_email_address: 'Author Email Address',
    exposed_code_link: 'Link to Exposed Code',
    customer: 'Customer',
    usernames: 'Users',
    machine_id: 'Machine ID',
    workgroup: 'Workgroup',
    country: 'Country',
    operating_system: 'Operating System',
    tool_name: 'Tool Name',
    confidence: 'Confidence',
    severity: 'Severity',
    expert_analysis: 'Expert Analysis',
    recommendations: 'Recommendations',
    virtual_path_recommendations: 'Virtual Patch Recommendations',
    threat_prevention_insights: 'Threat Prevention Insights',
    targetedBrand: 'Targeted Brand',
    targetedBrands: 'Targeted Brands',
    available_ips_protection: 'Available IPS Protection',
    quantum_gateway: 'Quantum Gateway',
    accountName: 'Account Name',
    matchingAsset: 'Matching Person Asset',
    targetedVector: 'Targeted Vector',
    threatActor: 'Threat Actor',
    sourceAuthor: 'Author',
    source: 'Source',
    intelItem: 'Intel Item',
    source_use_by: 'Source is used by',
    sourceCategory: 'Source Category',
    cwe: 'CWE',
    final_protocol: 'Target Protocol',
    final_host: 'Target Host',
    final_port: 'Target Port',
    attachments: 'Attachments',
    phone_number: 'Phone Number',
    profileDescription: 'Profile Description',
    additionalInformation: 'Additional Information',
    exploitationLog: 'Exploitation Log',
    quantumInsights: 'Quantum Insights',
    relatedEvents: 'Related intel items',
    relatedIssues: 'Related Exposure Items',
    lastAsmScan: 'Last ASM Scan',
    firstSeen: 'First Seen',
    lastSeen: 'Last Seen',
    exposureStatus: 'Exposure Status',
    relatedIOCs: 'Related IOCs',
    relatedEntities: 'Related Entities',
    related_assets: 'Related Assets',
    assets_to_port: 'Serving Hosts',
    related_alerts: 'Related Alerts',
    mitre_techniques: 'MITRE Techniques',
    asset_group: 'Asset Group',
    forensicsInvestigation: 'Forensics Investigation',
    status: 'Alert status',
    description: 'Description',
    intelItems: 'Intel Items',
    intelItemSummary: 'Raw Intel Summary',
    intelItemSummaryCountInfo: 'Summary is limited to the first %{count} indicators',
    aiSummary: 'AI Summary',
    aiSummaryNotAllowed: 'AI Summary is not permitted for you',
    aiSummaryNotAvailable: 'AI Summary is not available',
    aiDisclaimer:
      'This summary was generated using AI. It is intended to support operational workflows.\n' +
      'Please validate before making operational or strategic decisions.',
    comments: 'Comments',
    alertStatus: 'Alert Status',
    discussionBoard: 'Discussion',
    notesBoard: 'Notes',
    tags: 'Tags',
    logo: 'Logo',
    price: 'Price',
    bin_number: 'BIN Number',
    curl_command: 'CURL Command',
    curl_command_tooltip:
      'A curl command is a tool used in the command line or scripts to transfer data to or from a server using various network protocols, including HTTP, HTTPS, FTP, and more. ASM’s Active Exposure Validation uses curl commands to automate various HTTP requests as part of its scanning process.',
    evidence_description: 'Evidence Description',
    request: 'Request',
    response: 'Response',
    preview: {
      fullDetails: 'See full details',
      infoTab: 'Info',
      discussionTab: 'Discussion',
      notesTab: 'Notes',
      created: 'Created: ',
      id: 'ID: '
    },
    newAlerts: 'New Alerts',
    latestAlerts: 'Latest Alerts',
    mttarNotAvailable: 'The MTTA/MTTR is only available to users who have full access to all alert types',
    search: {
      selectedIds: '%{count} alerts selected',
      placeholder: 'Alert ID, Exposed Credentials, Payment Cards...'
    },
    confidenceReason: 'Confidence Reason',
    empty: {
      title: 'Great news!',
      items: 'There are currently no items to review.',
      alerts: 'There are currently no active alerts.',
      search: 'No matches were found.'
    },
    changeStatus: {
      title: 'Change status for multiple alerts',
      message: 'Are you sure you wish to change the status of the %{count} selected alerts to "%{status}"?'
    },
    changeSeverity: {
      title: 'Change severity for multiple alerts',
      message: 'Are you sure you wish to change the severity of the %{count} selected alerts to "%{severity}"?'
    },
    changeConfidence: {
      title: 'Change confidence for multiple alerts',
      message: 'Are you sure you wish to change the confidence of the %{count} selected alerts to "%{confidence}"?'
    },
    addNote: {
      title: 'Add note to multiple alerts',
      message: 'Are you sure you wish to add a note to the %{count} selected alerts?'
    },
    addDiscussion: {
      title: 'Add discussion to multiple alerts',
      message: 'Are you sure you wish to open a discussion for the %{count} selected alerts?'
    },
    bulkUpdateButton: 'Update %{count} alerts',
    bulkUpdateError: 'Something went wrong and we were unable to update the alerts. Please try again.',
    exportToXlsx: 'Export to XLSX',
    exportToCSV: 'Export to CSV',
    exportHandoutPdf: 'Generate Environment Summary Report',
    exportEnvSummaryTooltip:
      'The Environment Summary section in the report reflects only the currently open alerts. Changes to filters or to the number of selected alerts will not affect the Environment Summary section.',
    errorExportHandoutPdf: 'Failed to generate report. Please try again later',
    exportHandoutModal: {
      modalTitle: 'Enter the organization name',
      okButtonText: 'Generate'
    },
    xlsxLimit: 'It is possible to download up to 6K alerts at once',
    xlsx_downloaded_successfully: 'XLSX file generated successfully',
    failed_to_download_xlsx: 'Failed to download XLSX file',
    failed_to_download_csv: 'Failed to download CSV file',
    untitled: 'Untitled',
    publish_date: 'Publish Date',
    publish_date_tooltip:
      'The date of the oldest credential included in this alert at the time it was created. Intelligence items added afterward will not affect this date.',
    infection_date: 'Infection Date',
    shareAlerts: {
      buttonTitle: 'Share',
      modalTitle: 'Share Alert',
      sendButton: 'Send',
      emailWarning: 'Only users with credentials to Argos will be able to access the link',
      shareLinkToAlert: 'Share link to alert',
      shareAlertAsPdf: 'Share alert as PDF',
      additionText: 'Additional text (optional)',
      successMsg:
        'Alert was successfully shared with %{email} |||| Alert was successfully shared with %{smart_count} emails',
      successfullySentTitle: 'The %{type} was successfully sent to ',
      successfullySentSubTitle: '%{recipientEmail}',
      validationErrorMessage: 'Something went wrong and we were unable to share the alert. Please try again.',
      generalErrorMessage: 'Server Error (500)',
      emailRequired: 'Email is a required field',
      invalidEmail: 'Invalid email address',
      limitChars: 'The massage should be less than 1000 characters',
      emails: 'emails',
      numberOfRecepientsShouldBeLimited: 'The number of recepients should be limited to 100'
    },
    bulkAlertsFields: {
      status: {
        label: 'New Status'
      },
      resolution: {
        label: 'Resolution'
      },
      internalNote: {
        label: 'Internal Note',
        placeholder: 'Type a note'
      },
      discussion: {
        toggleLabel: 'Open a discussion with Check Point Analysts',
        label: 'Message',
        placeholder: 'Type a message',
        messageRequired: 'Message is required'
      },
      priority: {
        label: 'Priority'
      },
      severity: {
        label: 'New Severity'
      }
    },
    bulkChangeStatusModal: {
      title: 'Change Status'
    },
    bulkChangeSeverityModal: {
      title: 'Change Severity'
    },
    bulkAddNoteModal: {
      title: 'Add Note',
      note: {
        label: 'Note',
        placeholder: 'Type a note'
      },
      applyButton: 'Add Note to %{count} Alerts'
    },
    bulkAddDiscussionModal: {
      title: 'Open a discussion with analysts',
      message: {
        label: 'Message',
        placeholder: 'Type a message',
        messageRequired: 'Message is required'
      },
      applyButton: 'Open a Discussion for %{count} Alerts'
    }
  },
  closure_reason: {
    modal: {
      title: 'Set Closure Reason',
      set_button: 'Set',
      cancel_button: 'Cancel',
      discard_button: 'Discard',
      resolved_button: 'Resolved'
    },
    save_closure_reason: 'save',
    tooltips: {
      no_longer_a_threat:
        'This threat was already resolved or no longer a threat. We will continue monitoring for this type of threat.',
      asset_should_not_be_monitored: 'This asset should not be monitored.',
      asset_belongs_to_my_org:
        'You can stop such alerts by either monitoring this asset from now on, or adding it to the un-monitored assets, please mention in discussion board your choice.',
      irrelevant_alert_subtype:
        "Either this alert is not relevant for you at all, or it's relevant but for other assets.",
      false_positive:
        'This alert incorrectly indicates that a threat is present.\n\nIf you’re not sure it’s a false positive please write your thoughts in ‘Other’.',
      other:
        'If you’re not sure what to choose or want to provide additional info.\nPlease elaborate as much as possible.'
    },
    descriptions: {
      no_longer_a_threat: 'No longer a threat',
      asset_should_not_be_monitored: '"%{assetName}" shouldn\'t be monitored',
      asset_belongs_to_my_organization: '"%{assetName}" belongs to my org',
      irrelevant_alert_subtype: 'Alert subtype is irrelevant',
      false_positive: 'False positive',
      other: 'Other'
    },
    descriptions_bulk: {
      asset_should_not_be_monitored: "Assets shouldn't be monitored",
      asset_belongs_to_my_organization: 'Assets belong to my org',
      irrelevant_alert_subtype: 'Such alerts are irrelevant'
    },
    reason_description_resolve: 'Specify resolution details (optional)',
    reason_description_discard: 'Specify discarding details (mandatory)',
    reason_description_error: 'Please elaborate as much as possible',
    failed_to_fetch_asset: 'Failed to fetch asset',
    technology_relevance_warning: 'If this technology is no longer relevant, we suggest removing it or updating it in',
    technology_screen_link: 'Technology Screen',
    multiple_subtypes_instruction:
      "Some of the reasons are relevant only for some of the chosen alerts and therefore aren't showing. For choosing them, close those alerts in separate bulk edits.",
    filters: {
      no_longer_a_threat: 'No Longer a Threat',
      asset_should_not_be_monitored: "Asset Shouldn't Be Monitored",
      asset_belongs_to_my_organization: 'Asset Belongs To My Org',
      irrelevant_alert_subtype: 'Irrelevant',
      false_positive: 'False positive',
      other: 'Other',
      resolved: 'Resolved',
      asm_no_longer_detected: 'No longer detected by ASM [Automatically]',
      asm_manually_closed: 'Closed in ASM [Manually]'
    }
  },
  post_closure: {
    request_success: 'Notification was sent to review your request',
    request_fail: 'Failed to send notification',
    ok_not_allowed: 'Request a Review',
    ok_send_request: 'Yes - Send Request',
    no_keep_receiving: 'No - Keep Receiving',
    fp: {
      message_adjust: "To improve detection accuracy, you can review and adjust this alert's configuration.",
      message_request:
        "To improve detection accuracy, you can send a request to review and adjust this alert's configuration.",
      ok_allowed: 'Open Alert Configuration'
    },
    suppress: {
      message: 'You can choose to turn off such alert subtype so it won’t trigger again',
      success: 'Alert subtype was suppressed successfully',
      fail: 'Failed to suppress alert subtype',
      message_request: 'To improve detection accuracy, you can send a request to suppress this alert subtype.',
      ok_allowed: 'Turn off'
    },
    disable_asset: {
      message:
        'Would you like to disable monitoring of the asset (%{name}) behind the alert? |||| Would you like to disable monitoring of %{smart_count} assets behind the alert?',
      success:
        "Alert's asset (%{name}) was disabled successfully |||| Alert's %{smart_count} assets were disabled successfully",
      fail: "Failed to disable Alert's asset/s",
      message_request:
        'To improve detection accuracy, you can send a request to disable the asset (%{name}) behind the alert. |||| To improve detection accuracy, you can send a request to disable %{smart_count} assets behind the alert.',
      request_success:
        'Request to disable asset (%{name}) was sent successfully |||| Request to disable %{smart_count} assets was sent successfully',
      ok_allowed: 'Yes - Disable'
    }
  },
  drafts: {
    changeStatusMDP: {
      modal: {
        title: 'Change status of related ASM issues?',
        content: `There are related issues attached to the candidates you've selected to discard. Do you wish to update the status of these issues to "Irrelevant" in ASM?`,
        notice: `*Please note that irrelevant issues cannot be automatically reopened.`,
        btns: {
          yes: 'Yes',
          no: 'No'
        }
      }
    },
    undiscard: {
      undiscardButton: 'Undiscard'
    },
    cloneAlert: {
      title: 'Clone Alert',
      selectCustomer: 'Select a tenant',
      keepBrandInformation: 'Keep Brand and Entities fields',
      keepBrandTooltip:
        'Keeping Brand and Entities is relevant only when moving an alert for the same customer from a POC env to a production one',
      modal: {
        ok: 'OK',
        cancel: 'Cancel',
        title: 'Choose a tenant you wish to clone to'
      }
    },
    remove: {
      modal: {
        single: {
          title: 'Discard Item',
          content:
            'Are you sure you wish to discard the selected item? This will permanently remove it from the alerts center',
          remove: 'Discard',
          cancel: 'Cancel'
        },
        multiple: {
          title: 'Discard Items',
          content:
            'Are you sure you wish to discard %{count} selected items? This will permanently remove them from the alerts center',
          remove: 'Discard',
          cancel: 'Cancel'
        }
      },
      removeButton: 'Discard',
      removeDraftButton: 'Discard'
    },
    approve: {
      modal: {
        single: {
          title: 'Publish Item',
          content: 'Are you sure you wish to convert the selected item to an open alert?',
          subContent: 'This will send a “New Alert” notification to your customer',
          approve: 'Publish',
          cancel: 'Cancel'
        },
        multiple: {
          title: 'Publish Items',
          content: 'Are you sure you wish to convert the selected \n %{count} items to an open alert?',
          subContent: 'This will send a “New Alert” notification to your customer.',
          approve: 'Publish',
          cancel: 'Cancel'
        }
      },
      approveButton: 'Publish',
      approveDraftButton: 'Publish'
    },
    confidence: {
      modal: {
        single: {
          title: 'Low confidence level',
          content:
            'The item you are about to publish has a lower confidence level than the recommended level for this alert type. \nAre you sure you wish to continue?',
          yes: 'Publish',
          cancel: 'Cancel'
        },
        multiple: {
          title: 'Low confidence level',
          content:
            '%{count} of the items you are about to approve has a lower confidence level than the recommended level for this alert type. \nAre you sure you wish to continue?',
          yes: 'Publish',
          cancel: 'Cancel'
        }
      }
    },
    missingContent: {
      modal: {
        title: 'Missing content',
        content:
          '%{count} of the items you are trying to approve are missing valuable content, please add the content and retry. \n %{items}',
        ok: 'Ok'
      }
    },
    notes: {
      title: 'Notes',
      notification: '*Notes are only visible in review mode',
      typeMessage: 'Type a note',
      deleteCommentConfirmation: 'Are you sure you want to delete this note?',
      noNotes: 'No notes have \nbeen added yet'
    },
    draft_title: 'Draft',
    candidate_title: 'Candidate',
    created_by_system: 'System',
    backToReview: 'Back to Review',
    items_selected: 'Items Selected'
  },
  comments: {
    cyberint_support: '%{companyName} Support',
    analyst: 'Analyst',
    noComments: 'No comments have \nbeen added yet',
    noMessages: 'No messages have been added yet',
    typeMessage: 'Type a comment',
    typeMessagePlaceholder: 'Type a message',
    commentTooLong: 'Exceeds %{max} characters',
    deleteCommentConfirmation: 'Are you sure you want to delete this comment?',
    deleteComment: 'Delete',
    markedUrgent: 'Marked as urgent',
    urgentClick: 'Click to mark urgent',
    unUrgentClick: 'Click to mark regular',
    urgentMsg: 'This request has been flagged for special attention. To ensure timely support, please submit a ',
    needHelpLink: 'Support Ticket.',
    title: 'Update to Escalation Process',
    expand: 'Expand',
    collapse: 'Collapse'
  },
  lookalike: {
    manage: 'Lookalike Domains',
    no_domains_detected: 'No lookalike domains detected'
  },
  investigation: {
    loadingButton: 'Loading Investigation ...',
    createButton: 'Request Investigation',
    viewButton: 'View Investigation',
    gotoInvestigation: 'Go to Investigation',
    createSuccess: 'Request investigation succeeded',
    createFailed: 'Request investigation failed'
  },
  takedown: {
    title: 'Request Takedown',
    requested: 'View Takedown',
    urlRequired: 'URL is Required',
    submitting: 'Submitting...',
    loading: 'Loading...',
    modalConfirm: {
      phishing:
        'This action will both send a DMCA takedown request to the hosting provider and report the website to Google Safe Browsing for maximal effectiveness.\n\nNote: Once submitted to the providers the request is irreversible. By clicking submit you confirm that to the best of your knowledge the reported case is unauthorized.',
      brand:
        'This action will send a DMCA takedown request to the hosting provider.\n\nNote: Once submitted to the providers the request is irreversible. By clicking submit you confirm that to the best of your knowledge the reported case is unauthorized.'
    },
    errorCodeMessages: {},
    missingOriginalUrl: {
      title: 'Missing Details',
      text: 'To be able to send your takedown request, please provide the official URL of the copyrighted content',
      urlError: 'URL is Required'
    }
  },
  credsPurchased: {
    title: 'Request Purchase',
    requested: 'Purchase Requested',
    confirmMsg: 'Are you sure you want to request credentials purchase?',
    submitting: 'Submitting...',
    failedToCreate: 'Failed to sent a request'
  },
  common: {
    emptyAlert: 'Alert not found',
    openInIntelItem: 'Open Intel Item in Raw Intel',
    openAsset: 'Open Asset',
    draft_title: 'Draft',
    edit: 'Edit Alert',
    share: 'Share Alert',
    configureAlert: 'Configure Alert',
    exportAlert: 'Export Alert',
    warning: 'Warning',
    exportPdf: 'Export to PDF',
    downloadAnalysis: 'Download Expert Analysis File',
    exportPdfFailed: 'Failed to export PDF',
    exportPdfSuccess: 'PDF downloaded successfully',
    exportPdfWithCredentialsWarning: 'You are about to download a file that contains passwords in clear text',
    exportXls: 'Export to XLSX',
    publish: 'Publish',
    undiscard: 'Undiscard',
    discard: 'Discard',
    resolve: 'Resolve',
    prev: 'Previous Alert',
    next: 'Next Alert',
    candidate_title: 'Candidate',
    showLess: 'Show Less',
    showMore: 'Show More',
    na: 'N/A',
    add: 'Add',
    ti: 'TI',
    asm: 'ASM',
    cancel: 'Cancel'
  },
  error: {
    something_went_wrong: 'Something went wrong',
    fetchCsvFailed: 'Failed to fetch table data (csv)',
    fetchMDFailed: 'Failed to fetch Expert Analysis File',
    updateComment: 'Failed to update the comment',
    deleteComment: 'Failed to delete the comment',
    updateFailed: 'Failed to update alert'
  },
  update: {
    header: {
      title: 'Update Alert',
      titleDraft: 'Update Item',
      back: 'Back to Details',
      backDraft: 'Back to Item'
    },
    modal: {
      description: 'Description',
      recommendations: 'Recommendations',
      approve: {
        title: 'Publish Item',
        content:
          'Are you sure you wish to convert the selected item to an open alert? This will send a "New Alert" notification to your customer.'
      },
      missingDetails: {
        title: 'Missing content',
        content: '%{field} field is missing valuable content, please add content to be able to approve it as an alert',
        gotoEdit: 'Edit Alert',
        contentMulti:
          '%{field1} and %{field2} fields are missing valuable content, please add content to be able to approve it as an alert'
      },
      notificationConfirm: {
        title: 'Notify Other Users?',
        content:
          'Would you like to notify other users that the alert was updated? This will send an email notification to all \n relevant users.'
      }
    }
  },
  create: {
    header: {
      title: 'New Alert',
      by: 'By',
      publishButton: 'Publish',
      updateButton: 'Update',
      approveButton: 'Publish',
      edit: 'Edit',
      discard: 'Discard',
      saveDraft: 'Save as Draft',
      updateDraft: 'Update Item',
      back: 'Back to Alerts'
    },
    titles: {
      forensicsInvestigation: 'Forensics Investigation',
      generalDetails: 'General Details',
      description: 'Description',
      issues: 'Related Intel Item/Issues',
      recommendations: 'Recommendations*',
      textualDescription: 'Textual Description*',
      expertAnalysis: 'Expert Analysis',
      attachments: 'Attachments',
      targetedBrand: 'Targeted Brand',
      targetedVector: 'Targeted Vector',
      additionalInformation: 'Additional Information',
      relatedIOCs: 'Related IOCs',
      relatedEntities: 'Related Entities',
      relatedAssets: 'Related Assets',
      tags: 'Tags',
      iocType: 'Type',
      iocValue: 'Value',
      intelItem: 'Intel Item',
      untitled: 'Untitled'
    },
    labels: {
      confidence: 'Confidence*',
      severity: 'Severity*',
      type: 'Type*',
      title: 'Title*',
      subtype: 'Title*',
      issues: 'Intel Item / Issue ID',
      threat_actor: 'Threat Actor',
      publish_date: 'Published Date',
      source_category: 'Source Category*',
      source: 'Source',
      targeted_brands: 'Targeted Brand',
      targeted_vectors: 'Targeted Vector',
      description: 'Description',
      recommendation: 'Recommendations',
      investigation_id: 'Investigation',
      related_assets: 'Related Assets',
      customer: 'Customer',
      employee: 'Employee',
      business: 'Business',
      iocType: 'Type',
      iocValue: 'Value',
      whois: 'WHOIS'
    },
    placeholders: {
      relatedAssets: 'Enter a related asset'
    },
    modal: {
      exit: {
        title: 'Save changes',
        content: 'Do you wish to save the changes in current item?'
      },
      missingMandatoryFields: {
        title: 'Missing Mandatory Values',
        content: 'To save as draft, first fill all mandatory fields in the form and click the "Save as draft" button.'
      },
      changeRoute: {
        title: 'Save as Draft',
        content:
          'Please save the alert as draft before leaving this screen so that important information such as attachments or data tables will not be lost.',
        leave: 'Leave without saving',
        save: 'Save as draft'
      },
      close: 'Close'
    },
    snackbar: {
      success: 'Alert created successfully'
    },
    options: {}
  },
  upload: {
    dropFiles: 'Drop the files',
    dropFilesOr: 'Drop files to attach, or',
    browse: 'browse',
    fileTooLarge: '%{name}: File is too large (max %{max}MB)',
    invalidFileType: '%{name}: Unsupported file type',
    uploadFailed: '%{name}: Upload failed'
  },
  issues: {
    issue: 'Issue',
    exposure_item: 'Exposure Item',
    issueStatus: 'Issue status',
    exposureItemStatus: 'Exposure item status',
    description: {
      dmarc: 'Email Security',
      spf: 'Email Security',
      leaked_credentials: 'Compromised Credentials',
      ip_rbl: 'Mail Servers in Blocklist',
      open_ports: 'Exposed Ports',
      open_cloud_storage: 'Exposed Cloud Storage',
      hijackable_dns: 'Hijackable Subdomains',
      caa: 'Certificate Authority',
      open_web_interface: 'Exposed Web Interfaces',
      tls: 'SSL/TLS'
    },
    status: {
      open: 'Open',
      closed: 'Closed',
      irrelevant: 'Irrelevant',
      in_progress: 'In Progress',
      resolved: 'Resolved',
      inactive: 'Inactive'
    }
  },
  asset_type: {
    domain: 'Domain',
    url: 'URL',
    subdomain: 'Subdomain',
    company: 'Company',
    product: 'Brand',
    ip: 'IP Address',
    bin_number: 'BIN',
    email: 'Email Address',
    person: 'Person',
    mobile_application: 'Mobile App',
    sensitive_code_identifier: 'Sensitive Code Identifier',
    employee_login_interface: 'Employee Login Interface',
    document_identifier: 'Document Identifier',
    google_cloud_storage: 'Google Cloud Storage',
    azure_data_lake: 'Azure Data Lake',
    s3_bucket: 'S3 Bucket'
  },
  custom_fields: {
    ssl_tls_certificate_expiry: {
      issued_to: 'Issued To',
      issued_by: 'Issued By',
      issued_on: 'Issued On',
      expires_on: 'Expires On',
      expiry_status: 'Expiry Status',
      certificate_hash: 'Certificate Hash'
    },
    potential_ddos_attack: {
      target_ips: 'Targeted IPs'
    },
    exposed_directory_listing: {
      url: 'URL'
    },
    active_phishing_website_targeting_company: {
      url: 'URL',
      screenshot: 'Screenshot',
      detection_reasons: 'Detection Reason',
      url_reputation: 'URL Reputation',
      requests_user_details: 'Requests User Details',
      a_record: 'A Record',
      ip_reputation: 'IP Reputation',
      mx_records: 'MX Records',
      site_status: 'Site Status',
      registrar: 'Registrar',
      whois_created_date: 'WHOIS created date',
      registrant_name: 'Registrant Name',
      registrant_email: 'Registrant Email',
      nameservers: 'Name Servers',
      whois_record: 'WHOIS Record',
      has_ssl_certificate: 'Has SSL Certificate',
      /** because of the tags list translation of it in the chips is Super complicated and will cause a big refactoring
             /* !!!!!!! PAY ATTENTION YOU NEED TO CHANGE THE TEXT BELOW IN MORE PLACES IN THE FILE!!!!!!!!!!!!!
             */
      shared_hosting_provider: 'Shared hosting provider',
      owned_by_company: 'Owned by company',
      malicious: 'Malicious',
      unknown: 'Unknown',
      secure_login: 'Secure Login',
      unsecure_login: 'Unsecure Login',
      no_certificate: 'No certificate',
      valid_certificate: 'Valid certificate',
      invalid_certificate: 'Invalid certificate',
      similar_logo_detected: 'Similar logo detected',
      source_code_mentioned_assets: 'Source code mentioned assets',
      matching_favicon_detected: 'Matching Favicon detected',
      matching_resource_detected: 'Matching page resource detected',
      title_mentioned_assets: 'Title mentioned assets',
      url_mentioned_assets_or_twists: 'URL mentioned assets or their twists',
      url_matches: 'URL Matches Found',
      page_source_matches: 'Source Code Assets Found',
      logo: 'Similar Logo Found',
      'reproduction_parameters.referer': 'Referer',
      'reproduction_parameters.client_ip': 'Client IP',
      'reproduction_parameters.user_agent': 'User Agent'
    },
    brand_abusing_website_impersonating_company: {
      url: 'URL',
      screenshot: 'Screenshot',
      detection_reasons: 'Detection Reason',
      url_reputation: 'URL Reputation',
      requests_user_details: 'Requests User Details',
      a_record: 'A Record',
      ip_reputation: 'IP Reputation',
      mx_records: 'MX Records',
      site_status: 'Site Status',
      registrar: 'Registrar',
      whois_created_date: 'WHOIS created date',
      registrant_name: 'Registrant Name',
      registrant_email: 'Registrant Email',
      nameservers: 'Name Servers',
      whois_record: 'WHOIS Record',
      /** because of the tags list translation of it in the chips is Super complicated and will cause a big refactoring
             /* !!!!!!! PAY ATTENTION YOU NEED TO CHANGE THE TEXT BELOW IN MORE PLACES IN THE FILE!!!!!!!!!!!!!
             */
      shared_hosting_provider: 'Shared hosting provider',
      owned_by_company: 'Owned by company',
      malicious: 'Malicious',
      unknown: 'Unknown',
      secure_login: 'Secure Login',
      unsecure_login: 'Unsecure Login',
      no_certificate: 'No certificate',
      valid_certificate: 'Valid certificate',
      invalid_certificate: 'Invalid certificate',
      similar_logo_detected: 'Similar logo detected',
      source_code_mentioned_assets: 'Source code mentioned assets',
      url_mentioned_assets_or_twists: 'URL mentioned assets or their twists'
    },
    exposed_company_web_interface: {
      url: 'URL',
      package: 'Service',
      version: 'Service Version',
      name: 'CVE',
      interface_type: 'Interface Type',
      content: 'CSV',
      interface_version: 'Interface Version',
      cves: 'CVEs',
      is_internal: 'Is Internal',
      login: 'Login',
      certificate_status: 'Certificate Status',
      technologies_fields: {
        package: 'Product',
        version: 'Version',
        vendor: 'Vendor',
        cves_reference: 'CVE Reference',
        detected_cves: 'Detected CVEs',
        detected_cves_desc:
          'This reflects the detected CVEs at the time of the alert creation. The full and updated list of related CVEs can be found in CVE Intel.'
      },
      additional_technologies_detected: 'Additional Technologies Detected',
      technologies: 'Technologies CVEs',
      see_detected_cves: 'See Detected CVEs'
    },
    company_employee_corporate_credentials_exposed: {
      content: 'Credential Details',
      domain: 'Domain',
      total_first_seen: 'Total First Seen',
      source: 'Source',
      total_credentials: 'Total Credentials',
      csv_key: 'Credential Details'
    },
    lookalike_domain_potentially_targeting_company: {
      csv_key: 'Domain Details',
      content: 'Domain Details',
      number_of_domains: 'Number of Domains'
    },
    company_customer_credentials_offered_for_sale: {
      price: 'Price'
    },
    company_employee_credentials_offered_for_sale: {
      price: 'Price'
    },
    company_customer_payment_cards_offered_for_sale: {
      price: 'Price',
      bin_number: 'BIN Number',
      cvv: 'CVV',
      exp: 'Expiration Date'
    },
    company_subdomain_vulnerable_to_hijacking: {
      subdomain: 'Subdomain',
      vulnerable_cname_record: 'Vulnerable CNAME Record',
      service: 'Provider'
    },
    mobile_app_distributed_unofficially: {
      url: 'URL'
    },
    social_media_account_impersonating_company: {
      url: 'URL',
      logo: 'Similar Logo Found'
    },
    social_media_account_impersonating_company_executive: {
      url: 'URL'
    },
    mobile_app_impersonating_company: {
      url: 'URL'
    },
    malicious_file_employee_machine_infected_by_malware: {
      ip: 'Infected Host'
    },
    missing_company_domain_dmarc_records_detected: {
      domain: 'Domain'
    },
    misconfigured_company_domain_dmarc_records_detected: {
      domain: 'Domain',
      misconfiguration_type: 'Misconfiguration Type',
      dmarc_record: 'DMARC Record',
      misconfiguration_details: 'Misconfiguration Details',
      invalid_syntax: 'Invalid syntax',
      multiple_records: 'Multiple records',
      weak_record: 'Weak record',
      missing_report_destination: 'Missing report destination',
      non_authorized_report_destination: 'Non-authorized report destination'
    },
    company_source_code_exposed: {
      exposed_code_link: 'Link to Exposed Code',
      author_email_address: 'Author Email Address',
      code_leak_sample: 'Code Leak Sample'
    },
    missing_company_domain_spf_records_detected: {
      domain: 'Domain'
    },
    missing_company_domain_caa_records_detected: {
      domain: 'Domain'
    },
    credential_stuffing_tool_targeting_company: {
      tool_name: 'Tool Name'
    },
    data_scraping_tool_for_company_application: {
      tool_name: 'Tool Name'
    },
    brute_force_tool_targeting_company: {
      tool_name: 'Tool Name'
    },
    vulnerability_scanner_targeting_company: {
      tool_name: 'Tool Name'
    },
    exploitable_port_on_company_server_detected: {
      ip: 'IP Address',
      port: 'Port',
      port_description: 'Service Description',
      service: 'Service',
      service_cpe: 'Service CPE',
      service_version: 'Service Version',
      service_version_tooltip:
        'There could be a potential inconsistency between the Service Version range and the CPE Version. \n' +
        'The CVEs associated with the alert depend on the version specified in the CPE. However, the range of service versions may be broader or more limited than the CPE version.',
      cves: 'CVEs',
      additional_technologies_detected: 'Additional Technologies Detected',
      cve: 'CVE',
      link: 'Link',
      technology: 'Technology',
      version: 'Service Version',
      package: 'Service',
      name: 'CVE'
    },
    company_employee_private_access_token_exposed: {
      access_token: 'Access Token',
      access_token_type: 'Type',
      access_token_type_aws: 'AWS',
      aws: 'AWS',
      access_token_type_stripe: 'Stripe',
      access_token_type_sendgrid: 'Sendgrid',
      access_token_type_mailchimp: 'Malichimp',
      access_token_type_slack: 'Slack',
      access_token_type_artifactory: 'Artifactory',
      access_token_type_twilio: 'Twilio',
      access_token_type_nuGet: 'NuGet',
      nuGet: 'NuGet',
      access_token_type_google: 'Google',
      access_token_type_oauth: 'OAUTH',
      oauth: 'OAUTH',
      access_token_type_gcp: 'GCP',
      gcp: 'GCP',
      access_token_type_pypi: 'PyPI',
      pypi: 'PyPI',
      access_token_type_google_cloud: 'Google Cloud',
      access_token_type_square: 'Square',
      access_token_type_terraform_cloud: 'Terraform Cloud',
      access_token_type_clojars: 'Clojars',
      access_token_type_azure_storage: 'Azure Storage',
      access_token_type_shopify: 'Shopify',
      access_token_type_pulumi: 'Pulumi',
      access_token_type_proctorio: 'Proctorio',
      access_token_type_postman: 'Postman',
      access_token_type_adafruit_aio: 'Adafruit AIO',
      adafruit_aio: 'Adafruit AIO',
      access_token_type_dynatrace: 'Dynatrace',
      access_token_type_samsara: 'Samsara',
      access_token_type_sslmate: 'Sslmate',
      access_token_type_octobat: 'Octobat',
      access_token_type_datadog: 'Datadog',
      access_token_type_other: 'Other',
      interface: 'Interface',
      secret_key: 'Secret Key',
      consumer_key: 'Consumer Key',
      consumer_secret: 'Consumer Secret',
      username: 'Username',
      email: 'Email',
      repository_name: 'Repository Name',
      exposed_token_links: 'Link to Exposed Token',
      author_email_address: 'Author Email Address'
    },
    company_customer_payment_cards_exposed: {
      content: 'Payment Card Details',
      source: 'Source',
      total_first_seen: 'Total First Seen',
      total_payment_cards: 'Total Payment Cards',
      csv_key: 'Payment Card Details'
    },
    exposed_company_cloud_storage_bucket_detected: {
      storage_link: 'Storage Link',
      cloud_provider: 'Cloud Provider',
      files_in_storage: 'Files in Storage',
      main_file_types: 'Main File Types',
      aws: 'Amazon Web Services',
      gcp: 'Google Cloud Platform',
      microsoft_azure: 'Microsoft Azure',
      ibm_cloud_services: 'IBM Cloud Services',
      adobe_creative_cloud: 'Adobe Creative Cloud',
      kamatera: 'Kamatera',
      vmware: 'vmware',
      rackspace: 'Rackspace',
      red_hat: 'Red Hat',
      salesforce: 'Salesforce',
      oracle_cloud: 'Oracle Cloud',
      sap: 'SAP',
      verizon_cloud: 'Verizon Cloud',
      navisite: 'Navisite',
      dropbox: 'Dropbox',
      alibaba_cloud: 'Alibaba Cloud',
      digital_ocean_spaces: 'DigitalOcean Spaces',
      jpeg: 'jpeg',
      jpg: 'jpg',
      png: 'png',
      txt: 'txt',
      pdf: 'pdf',
      doc: 'doc',
      dot: 'dot',
      docx: 'docx',
      docm: 'docm',
      dotx: 'dotx',
      dotm: 'dotm',
      docb: 'docb',
      xls: 'xls',
      xlsx: 'xlsx',
      c: 'c',
      ccp: 'ccp',
      class: 'class',
      cs: 'cs',
      h: 'h',
      java: 'java',
      py: 'py',
      sh: 'sh',
      vb: 'vb'
    },
    misconfigured_company_domain_spf_records_detected: {
      domain: 'Domain',
      misconfiguration_type: 'Misconfiguration Type',
      spf_records: 'SPF Record',
      misconfiguration_details: 'Misconfiguration Details',
      invalid_syntax: 'Invalid Syntax',
      multiple_records: 'Multiple Records'
    },
    misconfigured_company_domain_caa_records_detected: {
      domain: 'Domain',
      misconfiguration_type: 'Misconfiguration Type',
      caa_records: 'CAA Records',
      misconfiguration_details: 'Misconfiguration Details',
      invalid_syntax: 'Invalid Syntax',
      missing_report_destination: 'Missing Report Destination'
    },
    company_mail_server_blacklisted: {
      mail_server: 'Mail Server',
      blacklist_repository: 'Blocklist Repository',
      ip_owner: 'IP Owner',
      hosting_provider: 'Hosting Provider',
      ip_reputation: 'IP Reputation',
      resolving_domains: 'Resolving Domains',
      malicious: 'Malicious',
      unknown: 'Unknown',
      shared_hosting_provider: 'Shared hosting provider',
      owned_by_company: 'Owned by company'
    },
    company_customer_credentials_exposed: {
      csv_key: 'Credential Details',
      username: 'Username',
      password: 'Password',
      designated_url: 'Designated URL',
      application: 'Application'
    },
    company_employee_third_party_credentials_exposed: {
      domain: 'Domain',
      total_first_seen: 'Total First Seen',
      total_credentials: 'Total Credentials',
      csv_key: 'Credential Details',
      content: 'Credential Details'
    },
    third_party_vendor_breached: {
      vendor_name: 'Vendor Name'
    },
    ransomware_attack_targeting_third_party_vendor: {
      vendor_name: 'Vendor Name'
    },
    vulnerable_technology_detected_on_exposed_company_asset: {
      cves: 'CVE',
      cyberint_score: 'Cyberint Score',
      service_product: 'Technology Name',
      service_vendor: 'Vendor Name',
      service_version: 'Technology Version',
      service_version_tooltip:
        'There could be a potential inconsistency between the Technology Version range and the CPE Version. \n' +
        'The CVEs associated with the alert depend on the version specified in the CPE. However, the range of technology versions may be broader or more limited than the CPE version.',
      security_controls: 'Security Controls'
    },
    vulnerable_technology_detected_on_manually_added_technology: {
      cves: 'CVE',
      cyberint_score: 'Cyberint Score',
      service_product: 'Technology Name',
      service_vendor: 'Vendor Name',
      service_version: 'Technology Version',
      service_version_tooltip:
        'There could be a potential inconsistency between the Technology Version range and the CPE Version. \n' +
        'The CVEs associated with the alert depend on the version specified in the CPE. However, the range of technology versions may be broader or more limited than the CPE version.'
    },
    highly_ranked_cve_found_on_a_technology: {
      cves: 'CVE',
      cyberint_score: 'Cyberint Score',
      service_product: 'Technology',
      service_cpe: 'Technology CPE',
      service_version: 'Technology Version',
      service_version_tooltip:
        'There could be a potential inconsistency between the Technology Version range and the CPE Version. \n' +
        'The CVEs associated with the alert depend on the version specified in the CPE. However, the range of technology versions may be broader or more limited than the CPE version.'
    },
    exploitable_vulnerability_found_on_company_asset: {
      cve: 'CVE',
      asset_value: 'Asset',
      port: 'Port',
      vendor: 'Vendor',
      version: 'Version',
      technology: 'Technology',
      available_ips_protection: 'Available IPS Protection',
      quantum_name: 'Quantum Gateway',
      security_controls: 'Security Controls'
    },
    exploit_found_on_company_asset: {
      cve: 'CVE',
      asset_value: 'Asset',
      template_name: 'Finding',
      port: 'Port',
      vendor: 'Vendor',
      version: 'Version',
      technology: 'Technology',
      curl_command: 'CURL Command',
      curl_command_tooltip:
        'A curl command is a tool used in the command line or scripts to transfer data to or from a server using various network protocols, including HTTP, HTTPS, FTP, and more. ASM’s Active Exposure Validation uses curl commands to automate various HTTP requests as part of its scanning process.',
      request: 'Request',
      response: 'Response'
    },
    web_app_security_missing_hsts_header_detected: {
      final_host: 'Target Host',
      final_port: 'Target Port',
      final_protocol: 'Target Protocol'
    },
    web_app_security_misconfigured_hsts_header_detected: {
      final_host: 'Target Host',
      final_port: 'Target Port',
      final_protocol: 'Target Protocol',
      record: 'Record',
      misconfiguration_details: 'Misconfiguration Details'
    },
    web_app_security_missing_x_frame_options_header_detected: {
      final_host: 'Target Host',
      final_port: 'Target Port',
      final_protocol: 'Target Protocol'
    }
  }
};
